import { DEFAULT_PAGE_SIZE, ORDER_BY } from '@app/constants/Common';
import { requestRemoveCandidateOutGroup } from "@app/services/CandidateGroupService";
import { requestCandidates } from '@app/services/CandidateService';
import { doExportExcel } from "@app/utils/CommonUtils";
import CandidateListTable, { CandidateListMode } from "@pages/candidate/list/CandidateListTable";
import QuickSearchCandidateInput from "@pages/candidate/list/SearchCandidateInput";
import SearchConditionInputNewModal from "@pages/candidate/list/SearchConditionInputNewModal";
import React, { useEffect, useState } from 'react';
import { toast } from "react-toastify";

const CandidateList = (props) => {
    const [candidates, setCandidates] = useState([]);
    const [allCandidateIds, setAllCandidateIds] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [numberPages, setNumberPages] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isExporting, setIsExporting] = useState(false);
    const [showSearchInputModal, setShowSearchInputModal] = useState(false);
    const [searchConditions, setSearchConditions] = useState({});
    const [quickSearchConditions, setQuickSearchConditions] = useState({});

    const [orderBy, setOrderBy] = useState(ORDER_BY.DESC_UPDATE_DATE);

    const groupId = new URLSearchParams(props.location.search).get("groupId")
    const paramCandidateId = new URLSearchParams(props.location.search).get("candidateId")
    const runDvtjcuv = new URLSearchParams(props.location.search).get("run_dvtjcuv")

    const searchCandidates = (page, newOrderBy, searchInputConditions, isExportExcel) => {
        setOrderBy(newOrderBy)
        setCurrentPage(page);
        if (!isExportExcel) {
            setIsLoading(true)
        } else {
            setIsExporting(true)
        }

        let params = {page: page, size: DEFAULT_PAGE_SIZE, order_by: newOrderBy}
        params.search_conditions = searchConditions
        if (!searchInputConditions) {
            searchInputConditions = {}
        }

        params.search_conditions = {...searchConditions, ...searchInputConditions, ...quickSearchConditions}
        setSearchConditions(params.search_conditions)

        if (paramCandidateId) {
            params.search_conditions.candidate_id = paramCandidateId
        }

        setSearchConditions(params.search_conditions)

        if (groupId) {
            params.group_id = groupId
        }

        if (runDvtjcuv) {
            params.run_dvtjcuv = runDvtjcuv
        }

        if (isExportExcel) {
            params.is_export_excel = isExportExcel
        }

        requestCandidates(params). then((res) => {
            console.log(`Response-CandidateList:${JSON.stringify(res)}`);
            if (isExportExcel) {
                doExportExcel(res.content.candidates)
            } else {
                setCandidates(res.content.candidates);
                setAllCandidateIds(res.content.all_candidate_ids);
                setTotalCount(res.content.totalCount)
                setCurrentPage(res.content.page)
                setNumberPages(Math.floor(Number(res.content.totalCount) / DEFAULT_PAGE_SIZE) + 1);
            }
        }).catch((error) => {
            console.log(`Error:${JSON.stringify(error)}`);
            // toast.error(`Có lỗi trong quá trình tải dữ liệu`);
            if (!isExportExcel) {
                setCandidates([]);
                setAllCandidateIds([]);
                setTotalCount(0)
                setNumberPages(0);
            }
        }).finally(() => {
            setIsLoading(false);
            setIsExporting(false);
        });
    }

    const onRemoveOutGroup = (canId) => {
        if (groupId && canId) {
            requestRemoveCandidateOutGroup({candidate_id: canId, group_id: groupId}).then((res) => {
                searchCandidates(currentPage, orderBy)
            }).catch((error) => {
                console.log(`Error:${JSON.stringify(error)}`);
                toast.error("Có lỗi xảy ra khi xóa Person.")
            }).finally(() => {
            });
        } else {
            toast.error("Không thể xóa Person.")
        }
    }

    const onExportExcel = () => {
        searchCandidates(currentPage, orderBy, searchConditions, true)
    }

    const onEmbeddedIntoJob = (jobId) => {
        searchConditions.embedded_job_id = jobId
        searchCandidates(currentPage, orderBy, searchConditions)
    }

    useEffect(() => {
        searchCandidates(currentPage, orderBy)
    }, []);

    return (
        <div className='container-fluid'>
            <div className='card card-primary'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>{groupId ? 'Danh sách Person' : 'Kho Person'}</h3>
                    <div className='card-tools'>
                        <a href='#'
                                className=''
                                onClick={() => {
                                    setShowSearchInputModal(true)
                                }}>
                            <i className='fas fa-filter mr-2'/>
                        </a>
                    </div>
                </div>
                <div className='card-body'>
                    <div style={{position: 'relative'}}>
                        {/* <SearchConditionInputModal isShow={showSearchInputModal}
                                                   onSearch={(searchInput) => searchCandidates(currentPage, orderBy, searchInput)}
                                                   onClose={() => setShowSearchInputModal(false)} /> */}
                        {/* {!hideSearchForm && */}
                        <QuickSearchCandidateInput
                            searchTitle={'Search'}
                            onChangeQuickSearch={(condition) => {
                                console.log("onChangeQuickSearch condition: ", condition)
                                setQuickSearchConditions(condition)
                            }}
                            onSearch={(condition) => searchCandidates(currentPage, orderBy, condition)}/>
                        {/* } */}
                        <SearchConditionInputNewModal isShow={showSearchInputModal}
                                                    // initialSearchConditions={searchConditions}
                                                   onSearch={(searchInput) => searchCandidates(currentPage, orderBy, searchInput)}
                                                   onClose={() => setShowSearchInputModal(false)} />
                        {/* <SearchConditionInputModal isShow={showSearchInputModal}/> */}
                        
                        <CandidateListTable candidates={candidates}
                                            allCandidateIds={allCandidateIds}
                                            totalCount={totalCount}
                                            canDelete={!!groupId}
                                            showBtnSelect
                                            mode={CandidateListMode.CANDIDATE_LIST}
                                            isExporting={isExporting}
                                            onDelete={(candidateId) => onRemoveOutGroup(candidateId)}
                                            onExportExcel={onExportExcel}
                                            onEmbeddedIntoJob={onEmbeddedIntoJob}
                                            onSearchCandidates={
                                                (page, searchOrderBy) => searchCandidates(page, searchOrderBy)}/>
                        {isLoading &&
                        <div className={'col-sm-12 text-center'}
                             style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
                            <div className='spinner-grow text-primary' role='status'>
                                <span className='sr-only'>Loading...</span>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CandidateList;
